import { inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { EfusTokenService } from '../../shared/formio-custom-components/file-upload-element/efus-token.service';
import { EnvironmentService } from '../services/environment.service';

/**
 * HTTP interceptor that attaches the EFUS Bearer token to requests
 * targeting the file upload service API. Skips internal endpoints and
 * requests that already have x-skip-auth.
 */
export function efusTokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const env = inject(EnvironmentService);
  const fileUploadBaseUrl = env.fileUploadServiceApiUrl;

  // Only intercept requests to the file upload service API
  if (!fileUploadBaseUrl || !req.url.startsWith(fileUploadBaseUrl)) {
    return next(req);
  }

  // Skip internal endpoints
  if (req.url.includes('/internal/')) {
    return next(req);
  }

  // Skip if opted out
  if (req.headers.has('x-skip-auth')) {
    return next(req);
  }

  const tokenService = inject(EfusTokenService);
  return tokenService.getToken().pipe(
    switchMap((token) => {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
      return next(authReq);
    }),
  );
}
